import { compactButtonGroupKey } from './';
import { createButtonDriver } from '../../new-libby/drivers';
import { createFloaterMenuDriver } from '../floater-menu/driver';
export var createCompactButtonGroupDriver = function (wrapper, global) {
    var base = wrapper.$("." + compactButtonGroupKey);
    var primaryButton = createButtonDriver(wrapper, 0);
    var menuDropdownButton = createButtonDriver(wrapper, 1);
    var floaterMenu = createFloaterMenuDriver(global);
    return {
        clickPrimaryButton: function () { return primaryButton.click(); },
        primaryButtonDisabled: function () { return primaryButton.isDisabled(); },
        primaryButtonLoading: function () { return primaryButton.isLoaderVisible(); },
        menuButtonDisabled: function () { return menuDropdownButton.isDisabled(); },
        openMenu: function () { return menuDropdownButton.click(); },
        selectItem: function (idx) { return floaterMenu.select(idx); },
        selectItemByClass: floaterMenu.selectByClass,
        menuItemDisabled: function (idx) { return floaterMenu.disabled(idx); },
        menuActionsCount: function () { return floaterMenu.getItemsCount(); },
        menuOpen: function () { return floaterMenu.base.exists(); },
        primaryButtonExists: function () { return base.$('.primary-button').exists(); },
        additionalActionsMenuExists: function () { return base.$('.open-menu-button').exists(); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map